<template>
  <v-container grid-list-xs class="d-flex justify-center align-center my-10">
    <v-card class="card-width card-radius card-shadow my-16" elevation="0">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium px-10"
        >{{ major.name }}</v-card-title
      >
      <v-container class="py-8">
        <div class="content px-5">
          <expandable-image
            :src="require(`@/assets/img/${major.url}.png`)"
            class="image"
            :alt="major.name"
            :close-on-background-click="true"
          ></expandable-image>
        </div>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "JurusanDetail",
  data: () => ({
    major: "",
  }),
  mounted() {
    const info = this.$route.params.major;

    switch (info) {
      case "teknik-grafika":
        this.major = {
          name: "DKV Konsentrasi Teknik Grafika",
          url: "produksi-grafika",
        };
        break;
      case "desain-grafika": {
        this.major = {
          name: "DKV Konsentrasi Desain Grafika",
          url: "desain-grafika",
        };
        break;
      }
      case "pengembangan-perangkat-lunak-gim": {
        this.major = {
          name: "Pengembangan Perangkat Lunak dan Gim",
          url: "rekayasa-perangkat-lunak",
        };
        break;
      }
      case "animasi-3d": {
        this.major = {
          name: "Animasi 3D",
          url: "animasi",
        };
        break;
      }
      case "animasi-2d": {
        this.major = {
          name: "Animasi 2D",
          url: "desain-komunikasi-visual",
        };
        break;
      }
    }
  },
};
</script>


<style scoped>
.dark-blue {
  background-color: #24305e !important;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.card-width {
  width: 60%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.berkas-section {
  min-height: 80vh;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 100%;
  }
}
</style>